<template>
    <v-card
            :class="cardClass"
            max-width="500"
            color="grey darken-2"
            @mouseover="cardClass=clickable ? 'mt-5 elevation-11 cursor-pointer' : 'mt-5 elevation-11'"
            @mouseout="cardClass='mt-5'"
            @click="cardClicked"
    >
        <v-card
                class="v-sheet--offset mx-auto"
                :color="color"
                elevation="12"
                max-width="calc(100% - 25%)"
        >

            <v-card-text class="subtitle-1 text-center pa-2 font-weight-medium">
                {{title.toUpperCase()}}
            </v-card-text>

        </v-card>

        <v-card-text class="pt-0">

            <retro-value
                    class="pb-2"
                    :value="boxValue.toLocaleString()"
                    :title="subTitle"
                    :prefix="prefix"
                    :prefix-icon="prefixIcon"
                    :postfix="postfix ? postfix : autoPostfixValue"
                    :postfix-icon="postfixIcon"

            ></retro-value>

            <div v-if="hint">
                <v-divider class="my-2"></v-divider>
                <v-icon class="mr-2" small color="grey lighten-1">
                    mdi-information-outline
                </v-icon>
                <span class="caption grey--text text--lighten-1 font-weight-light">{{hint}}</span>
            </div>

        </v-card-text>
    </v-card>
</template>

<script>

    import Counter from './Counter';
    import RetroValue from "./RetroValue";

    export default {

        components: {
            RetroValue,
            Counter,
        },

        props: {
            'value': {
                type: Number,
                required: true,
                default: 0,
            },
            'prefix': {
                type: String,
                required: false,
                default: null,
            },
            'prefixIcon': {
                type: String,
                required: false,
                default: null,
            },
            'postfix': {
                type: String,
                required: false,
                default: null,
            },
            'postfixIcon': {
                type: String,
                required: false,
                default: null,
            },
            'title': {
                type: String,
                required: true,
            },
            'subTitle': {
                type: String,
                required: true,
            },
            'hint': {
                type: String,
                required: false,
                default: null,
            },
            'height': {
                type: Number,
                required: false,
                default: 100
            },
            'color': {
                type: String,
                required: false,
                default: 'primary'
            },
            'loading': {
                type: Boolean,
                required: false,
                default: false,
            },
            'autoPostfix': {
                type: Boolean,
                required: false,
                default: false,
            },
            'clickable': {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {
                cardClass: 'mt-5',
                boxValue: 0,
                autoPostfixValue: null,
            }
        },

        watch: {

            value(newCount, currentCount) {

                currentCount = this.processValue(currentCount);
                newCount = this.processValue(newCount);

                // Prevent double animation
                if (this.animate && !this.animationRunning) {

                    this.animationRunning = true;

                    let diff = null;
                    let step = 1;

                    if (newCount > currentCount) {
                        diff = newCount - currentCount;
                        step = Math.floor(diff / 100);
                    } else {
                        diff = currentCount - newCount;
                        step = Math.floor(diff / 100) * -1;
                    }

                    let timer = setInterval(() => {
                        this.boxValue += step;
                    }, 10);

                    setTimeout(() => {
                        clearInterval(timer);
                        this.boxValue = newCount;
                        this.animationRunning = false;
                    }, 1000);
                }

                if (!this.animate) {
                    this.boxValue = newCount;
                }
            },
        },

        methods: {

            cardClicked() {
                if (this.clickable) {
                    this.$emit('click');
                }
            },

            processValue(value) {
                if (this.autoPostfix) {
                    if (value >= 10000 && value < 10000000) {
                        this.autoPostfixValue = 'k';
                        return Math.round(value / 1000);
                    } else if (value >= 10000000) {
                        this.autoPostfixValue = 'M'
                        return Math.round(value * 100 / 1000000) / 100;
                    }
                }
                this.autoPostfixValue = null;
                return value;
            }
        },

        mounted() {
            this.boxValue = this.processValue(this.value);
        }
    }
</script>

<style scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }
</style>
